export default __webpack_public_path__ + "static/plant-2006b1b50a5035da11a5515b239ca65e.png";